// @flow
import WebComponent   from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

const fragments = {
    BTN_SHOW: '[data-fragment="btnShowProducts"]',
    LIST: '[data-fragment="ExtendedFilters.item.list"]'
};

export default class FilterContents extends WebComponent {
    didMount() {
        const {
            storeCookie,
        } = this.props;

        const showBtn  = this.element.querySelector(fragments.BTN_SHOW); // show button
        const itemList = this.element.querySelector(fragments.LIST); // parameters list

        if (showBtn) {
            showBtn.addEventListener('click', function(e) {
                cookie.set(storeCookie, false, {expires: 1, path: '/'});
            });
        }

        if (itemList) {
            if (cookie.get('productTypeScrollTop')) {
                itemList.scrollTop = cookie.get('productTypeScrollTop');
            }

            itemList.addEventListener('scroll', function (e) {
                cookie.set('productTypeScrollTop', this.scrollTop, {expires: 1, path: '/'});
            });
        }
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FilterContents.js